import searchInList from '../../../utils/searchInList'

export default {
  components: {
    OrganicModal: () => import('~/components/Molecules/Organic/Modal/Modal.vue'),
  },

  props: {
    home: {
      type: Array[Object],
    },
    propBus: {
      type: Object,
    },
  },

  computed: {
    homeComputed() {
      const homeComputed = searchInList.searchByName(this.home, 'legal.home')

      return homeComputed
    },

    footer() {
      return {
        ...this.$t('components.footer'),
        availableLocales: ['pt-BR', 'en', 'es', 'fr'],
      }
    },
  },
}
